"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.round = exports.internalFormatNumber = exports.ShowColorEnum = exports.ShowSignEnum = exports.formatNumberAmountField = exports.setCaretPosition = exports.getCaretPosition = exports.operatorFromSign = exports.signFromValue = exports.chopValue = exports.formatNumber = exports.pruneString = void 0;
const numeral_1 = __importDefault(require("numeral"));
const currency_symbol_map_1 = __importDefault(require("currency-symbol-map"));
const utils_1 = require("utils/utils");
const pruneString = (value) => {
    let str = '';
    const legalChars = '0123456789.';
    for (let i = 0; i < value.length; i += 1) {
        // only keep legal characters (only numbers and decimals)
        str += legalChars.indexOf(value[i]) < 0 ? '' : value[i];
    }
    return str;
};
exports.pruneString = pruneString;
const formatNumber = (value, fmtString = '0,0.00') => `${(0, numeral_1.default)(Math.abs(Number(value))).format(fmtString)}`;
exports.formatNumber = formatNumber;
const chopValue = (value, decimals = 2) => {
    const periodIndex = value.indexOf('.');
    if (periodIndex > -1 && value.length > periodIndex + decimals) {
        return value.slice(0, periodIndex + decimals);
    }
    return value;
};
exports.chopValue = chopValue;
const signFromValue = (value) => {
    switch (Math.sign(value)) {
        case 1:
            return '+';
        case -1:
            return '-';
        default:
            return '';
    }
};
exports.signFromValue = signFromValue;
const operatorFromSign = (operator, negator) => {
    switch (operator) {
        case '+':
            return 1;
        case '-':
            return -1;
        default:
            return negator;
    }
};
exports.operatorFromSign = operatorFromSign;
const getCaretPosition = (el) => {
    let caretPos = 0;
    if (typeof window.getSelection !== 'undefined' && el) {
        const selection = window.getSelection();
        if (selection && selection.rangeCount) {
            const range = selection.getRangeAt(0);
            const selected = range.toString().length;
            const preCaretRange = range.cloneRange();
            preCaretRange.selectNodeContents(el);
            preCaretRange.setEnd(range.endContainer, range.endOffset);
            caretPos = preCaretRange.toString().length - selected;
        }
    }
    return caretPos;
};
exports.getCaretPosition = getCaretPosition;
const setCaretPosition = (el, offset) => {
    if (typeof window.getSelection !== 'undefined') {
        const range = document.createRange();
        const sel = window.getSelection();
        range.setStart(el.firstChild, offset);
        range.collapse(true);
        sel === null || sel === void 0 ? void 0 : sel.removeAllRanges();
        sel === null || sel === void 0 ? void 0 : sel.addRange(range);
    }
};
exports.setCaretPosition = setCaretPosition;
const formatNumberAmountField = (val, currencySymbol = 'USD', fmtString = '0,0', showSign = ShowSignEnum.NEGATIVE_ONLY) => {
    return (0, exports.internalFormatNumber)(val, (0, currency_symbol_map_1.default)(currencySymbol || 'N/A') || '', fmtString, showSign);
};
exports.formatNumberAmountField = formatNumberAmountField;
var ShowSignEnum;
(function (ShowSignEnum) {
    ShowSignEnum["NEGATIVE_ONLY"] = "negative-only";
    ShowSignEnum["POSITIVE_ONLY"] = "positive-only";
    ShowSignEnum["NEVER"] = "never";
    ShowSignEnum["ALWAYS"] = "always";
})(ShowSignEnum = exports.ShowSignEnum || (exports.ShowSignEnum = {}));
var ShowColorEnum;
(function (ShowColorEnum) {
    ShowColorEnum["MANUAL"] = "manual";
    ShowColorEnum["NEGATIVE_ONLY"] = "negative-only";
    ShowColorEnum["POSITIVE_ONLY"] = "positive-only";
    ShowColorEnum["ALWAYS"] = "always";
})(ShowColorEnum = exports.ShowColorEnum || (exports.ShowColorEnum = {}));
;
const internalFormatNumber = (val, currencyString, fmtString, showSign = ShowSignEnum.NEGATIVE_ONLY) => {
    const value = (0, utils_1.noNaN)((0, exports.round)(Number(val)));
    let sign = '';
    switch (showSign) {
        case ShowSignEnum.POSITIVE_ONLY:
            sign = Number(value) > 0 ? '+' : '';
            break;
        case ShowSignEnum.NEVER:
            sign = '';
            break;
        case ShowSignEnum.ALWAYS:
            sign = Number(value) > 0 ? '+' : '-';
            if (Number(value) === 0)
                sign = '';
            break;
        default:
        case ShowSignEnum.NEGATIVE_ONLY:
            sign = Number(value) < 0 ? '-' : '';
    }
    return `${sign}${currencyString}${(0, numeral_1.default)(Math.abs(Number(value))).format(fmtString)}`;
};
exports.internalFormatNumber = internalFormatNumber;
const round = (value, decimals = 2) => {
    const roundedValue = Math.round(Number(`${value}e${decimals}`));
    return Number(`${roundedValue}e-${decimals}`);
};
exports.round = round;
